import { authConstants } from './../constants/auth-constants';
import  LoginService  from './../services/auth-service'
import  UserService  from './../services/user-service'

export const authentication = (data) => async (dispatch) => {
    try {
      const res = await LoginService.userLogin(data);
  
      dispatch({
        type: authConstants.LOGIN_SUCCESS,
        payload: res.data,
      });
  
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }
  };

  export const getUser = () =>  async (dispatch) => {
    try {
      const res = await UserService.getloggedInUserDetails();
  
      dispatch({
        type: authConstants.GET_USER,
        payload: res.data,
      });
  
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }
  };

  export const verifyEmail = (data) =>  async (dispatch) => {
    try {
      const res = await LoginService.verifyEmail(data);
  
      dispatch({
        type: authConstants.VERIFY_EMAIL,
        payload: res.data,
      });
  
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }

   
};

export const verifyEmailAddress = (data) =>  async (dispatch) => {
  console.log(data)
  dispatch({
    type: authConstants.VERIFY_EMAIL_ADDRESS,
    payload: data,
  });
}
  